import { useTranslation } from 'react-i18next';

import { Badge, type BadgeVariant } from '@/components/ui/badge';
import type { SupportTicketPriority, SupportTicketStatus } from '@/pages/support/types';

export const statusBadgeVariant = (status: SupportTicketStatus): BadgeVariant => {
  switch (status) {
    case 'open':
    case 'awaiting_platform':
      return 'info';
    case 'awaiting_church':
      return 'warning';
    case 'escalated':
      return 'danger';
    case 'resolved':
      return 'success';
    case 'closed':
      return 'neutral';
    default:
      return 'neutral';
  }
};

export const priorityBadgeVariant = (priority: SupportTicketPriority): BadgeVariant => {
  switch (priority) {
    case 'low':
      return 'neutral';
    case 'normal':
      return 'info';
    case 'high':
      return 'warning';
    case 'urgent':
      return 'danger';
    default:
      return 'neutral';
  }
};

export const SupportTicketStatusBadge = ({ status }: { status: SupportTicketStatus }) => {
  const { t } = useTranslation('support');
  return <Badge variant={statusBadgeVariant(status)}>{t(`status.${status}`)}</Badge>;
};

export const SupportTicketPriorityBadge = ({ priority }: { priority: SupportTicketPriority }) => {
  const { t } = useTranslation('support');
  return <Badge variant={priorityBadgeVariant(priority)}>{t(`priority.${priority}`)}</Badge>;
};
